// @flow
const AdBreakType: PKAdBreakTypes = {
  PRE: 'preroll',
  MID: 'midroll',
  POST: 'postroll',
  OVERLAY: 'overlay'
};

export {AdBreakType};



// WEBPACK FOOTER //
// ./ads/ad-break-type.js


// WEBPACK FOOTER //
// core/ads/ad-break-type.js